import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createBrand, updateBrand, selectBrands } from "./brandsSlice";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IconButton from "@material-ui/core/IconButton";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { checkFieldUpdate } from "../../common/utils";
import { makeStyles, withStyles } from "@material-ui/core/styles";

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  outer: { display: "flex", flexFlow: "column" },
  addIcon: {
    marginRight: 8,
    color: "#fff",
  },
  title: {
    color: "#fff",
    padding: 16,
    backgroundColor: " #42494E",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
  },
  textItem: {
    marginBottom: 16,
  },
}));

export default function Brand(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const classes = useStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [editBrand, setEditBrand] = useState(false);
  const [statusID, setStatusID] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "active" },
    { id: 2, value: "inactive" },
    { id: 3, value: "deleted" },
    { id: 4, value: "unavailable" },
  ]);
  const [brandStatus, setBrandStatus] = useState("");
  const { editing, brand, brandsAmount } = useSelector(selectBrands);
  useEffect(() => {
    if (editing && brand !== {} && brand.name !== name && brand.statusID) {
      setName(brand.name);
      setDescription(brand.description);
      setStatusID(brand.statusID);
      setBrandStatus(statusList[brand.statusID - 1].value);
      setEditBrand(true);
      setOpen(true);
    }
  }, [brand]);

  const handleClickOpen = () => {
    setName("");
    setDescription("");
    setStatusID([]);
    setBrandStatus("");
    setEditBrand(false);

    setOpen(true);
  };

  const handleClose = () => {
    setName("");
    setDescription("");
    setStatusID([]);
    setBrandStatus("");
    setEditBrand(false);

    setOpen(false);
  };

  const handleStatusChange = (event) => {
    let selectedStatus = statusList.filter(
      (status) => status.value === event.target.value
    );
    selectedStatus[0] && setStatusID(selectedStatus[0].id);

    setBrandStatus(event.target.value);
  };

  const handleCreate = (e) => {
    e.preventDefault();
    let brandData = {
      statusID: statusID,
      name: name,
      description: description,
    };

    dispatch(
      createBrand({
        brand: brandData,
        token: jwtToken,
        brandsAmount: brandsAmount,
      })
    );
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    const updatedBrandFields = checkFieldUpdate(
      [
        { name: "statusID", val: statusID },
        { name: "name", val: name },
        { name: "description", val: description },
      ],
      brand
    );

    dispatch(
      updateBrand({
        brand: updatedBrandFields,
        token: jwtToken,
        id: brand.id,
        brandsAmount: brandsAmount,
      })
    );
  };

  return (
    <div>
      <IconButton
        aria-label={editBrand ? "edit brand" : "add brand"}
        style={{ marginLeft: 0 }}
      >
        <AddCircleIcon
          style={{ marginRight: 0, color: "#fff" }}
          onClick={handleClickOpen}
        />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <form
          onSubmit={editBrand ? (e) => handleUpdate(e) : (e) => handleCreate(e)}
        >
          <DialogTitle
            disableTypography
            className={classes.title}
            id="form-dialog-title"
          >
            {editBrand ? "Edit Brand" : "Add Brand"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{ paddingTop: 8, textAlign: "center" }}>
              {editBrand ? "Update Brand Details" : "Enter Brand Details"}
            </DialogContentText>
            <Grid container direction="column">
              <Grid item sm>
                <TextField
                  className={classes.textItem}
                  defaultValue={name}
                  variant="outlined"
                  autoFocus
                  margin="dense"
                  required
                  id="name"
                  label="Name"
                  type="name"
                  fullWidth
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>{" "}
              <Grid item sm>
                <TextField
                  defaultValue={description}
                  className={classes.textItem}
                  variant="outlined"
                  multiline
                  rows={4}
                  margin="dense"
                  id="description"
                  label="Description"
                  type="description"
                  fullWidth
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Grid>
              <Grid item sm style={{ paddingTop: 8 }}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{
                    width: "100%",
                  }}
                >
                  <InputLabel htmlFor="outlined-status-simple" margin="dense">
                    Brand Status*
                  </InputLabel>
                  <Select
                    defaultValue={statusID}
                    value={brandStatus}
                    onChange={(e) => handleStatusChange(e)}
                    margin="dense"
                    label="Brand Status"
                    required
                    inputProps={{
                      name: "status",
                      id: "outlined-status-simple",
                    }}
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                    <MenuItem value="unavailable">Unavailable</MenuItem>
                    <MenuItem value="deleted">Deleted</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            style={{ paddingLeft: 24, paddingRight: 24, paddingBottom: 16 }}
          >
            <Grid container spacing={2} direction="row">
              <Grid item sm>
                <ColorButton onClick={handleClose} color="primary">
                  Cancel
                </ColorButton>
              </Grid>
              <Grid item sm>
                <ColorButton
                  type="submit"
                  // onClick={editBrand ? handleUpdate : handleCreate}
                  color="secondary"
                >
                  {editBrand ? "Edit Brand" : "Create Brand"}
                </ColorButton>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
